import BioPanel from '@components/BioPanel/BioPanel';
import useAnalytics from '@hooks/useAnalytics';
import { Actions, Locales, Practitioner } from '@packages/types';
import { TextButton } from '@packages/ui-web';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';

type Props = {
  practitioner: Practitioner;
  locale: Locales;
};

export default function PractitionerInfo({ practitioner, locale }: Props) {
  const [bioPanelOpen, setBioPanelOpen] = useState(false);
  const { t } = useTranslation(['booking', 'common']);
  const setEventProps = useAnalytics();

  const closePanel = () => setBioPanelOpen(false);

  function toggleDrawer() {
    setBioPanelOpen((prev) => !prev);

    if (bioPanelOpen) {
      setEventProps({
        event: {
          action: Actions.OpenPractitionerInfo,
          practitionerId: practitioner.id,
        },
      });
    }
  }

  return (
    <div>
      <div className="mb-4 flex flex-row items-center space-x-4">
        <Image
          src={practitioner.photoUrl || '/illustrations/square-doctor.png'}
          alt={t('practitioner_image_alt', {
            ns: 'common',
            name: practitioner.name,
          })}
          width={56}
          height={56}
          className="h-20 w-20 rounded-full object-cover"
        />
        <div className="flex flex-col">
          <h2 className="text-[20px] font-normal">{practitioner.name}</h2>
          <TextButton
            text={t(
              'steps.select_datetime.summary.practitioner_read_more_button',
            )}
            onClick={toggleDrawer}
          />
        </div>
      </div>

      <BioPanel isOpen={bioPanelOpen} closePanel={closePanel}>
        <div className="flex flex-col gap-4 overscroll-contain">
          <h2 className="flex items-center gap-2 font-medium">
            <Image
              src={practitioner.photoUrl || '/illustrations/square-doctor.png'}
              alt={t('practitioner_image_alt', {
                ns: 'common',
                name: practitioner.name,
              })}
              width={56}
              height={56}
              className="h-20 w-20 rounded-full object-cover"
            />
            {practitioner.name}
          </h2>
          <p className="overscroll-contain text-sm">
            {practitioner.description[locale]}
          </p>
        </div>
      </BioPanel>
    </div>
  );
}
